module.exports = __webpack_public_path__ + "static/img/sd.f40649e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/sd.png
// module id = S/7D
// module chunks = 1